/*
 * @Author: Yun
 * @Date: 2023-12-11 10:53:14
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-28 12:56:40
 */
import React from 'react'
import './index.less'

const PREFIX = 'bottom-page'

const BottomPage = (props) => {
    /**
     * 此组件是为了上翻特效而将底部集结等内容整合成一个组件
     */
    return (
        <div className="bottom-page">
            <div className="history-wrapper">
                <div className="history-wrapper-top">
                    <a href="https://cp.cgtn.com/2016/" target="_blank">
                        <div className="history-1 history-item">
                            <div className="year">2016</div>
                        </div>
                    </a>
                    <a href="https://cp.cgtn.com/index.html" target="_blank">
                        <div className="history-2 history-item">
                            <div className="year">2017</div>
                        </div>
                    </a>
                    <a href="https://news.cgtn.com/event/2018/China2018/index.html" target="_blank">
                        <div className="history-3 history-item">
                            <div className="year">2018</div>
                        </div>
                    </a>
                    <a href="https://news.cgtn.com/event/2019/China2019/index.html" target="_blank">
                        <div className="history-4 history-item">
                            <div className="year">2019</div>
                        </div>
                    </a>
                </div>
                <div className="history-wrapper-bottom">
                    <a
                        href="https://news.cgtn.com/event/2020/decisiveyear/index.html"
                        target="_blank"
                    >
                        <div className="history-5 history-item">
                            <div className="year">2020</div>
                        </div>
                    </a>
                    <a href="https://news.cgtn.com/event/2021/China2021/index.html" target="_blank">
                        <div className="history-6 history-item">
                            <div className="year">2021</div>
                        </div>
                    </a>
                    <a href="https://news.cgtn.com/event/2022/China2022/index.html" target="_blank">
                        <div className="history-7 history-item">
                            <div className="year">2022</div>
                        </div>
                    </a>
                    <a href="https://news.cgtn.com/event/2023/China2023/index.html" target="_blank">
                        <div className="history-8 history-item">
                            <div className="year">2023</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default BottomPage
